import { render, staticRenderFns } from "./PlaneTickets.vue?vue&type=template&id=48fb1f0b&scoped=true"
import script from "./PlaneTickets.vue?vue&type=script&lang=js"
export * from "./PlaneTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fb1f0b",
  null
  
)

export default component.exports